import Swiper from "swiper/bundle";

function initSwiper() {
  const screenWidth = window.innerWidth;
  if (screenWidth < 1024) {
    // Initialize Swiper with your desired options
    const swiper = new Swiper(".blog-swiper", {
      slidesPerView: 2.8,
      pagination: false,
      breakpoints: {
        320: {
          slidesPerView: 1.1,
        },
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3.1,
        },
      },
    });
  }
}

initSwiper();

window.addEventListener("resize", initSwiper);
